export const filterNewConst = {
  RESET_FILTER_DOCUMENT: 'RESET_FILTER_DOCUMENT',
  APPLY_TYPE_ID: 'APPLY_TYPE_ID',
  APPLY_COMPANY_ID: 'APPLY_COMPANY_ID',
  APPLY_TOPIC: 'APPLY_TOPIC',
  APPLY_DATE_RANGE: 'APPLY_DATE_RANGE',
  APPLY_DATE_RANGE_FIELD: 'APPLY_DATE_RANGE_FIELD',
  APPLY_STATUSES: 'APPLY_STATUSES',
  APPLY_SUBTYPES: 'APPLY_SUBTYPES',
  APPLY_BIND_DOCUMENT: 'APPLY_BIND_DOCUMENT', //
  APPLY_BIND_DOCUMENT_NUMBER: 'APPLY_BIND_DOCUMENT_NUMBER', //
  APPLY_EXECUTOR: 'APPLY_EXECUTOR',
  APPLY_RESPONSIBLE_WORKER: 'APPLY_RESPONSIBLE_WORKER',
  APPLY_ORGS: 'APPLY_ORGS',
  APPLY_CREATOR: 'APPLY_CREATOR',
  APPLY_STREET: 'APPLY_STREET',
  APPLY_HOUSE: 'APPLY_HOUSE',
  APPLY_FLATS: 'APPLY_FLATS',
  APPLY_VIEW_OTHERO_DOCS_SELECTED: 'APPLY_VIEW_OTHERO_DOCS_SELECTED',
  SET_FILTER_CHANGE: 'SET_FILTER_CHANGE',
  SET_DOCUMENT_FILTER_VALUES: 'SET_DOCUMENT_FILTER_VALUES',
  APPLY_DEADLINE_DATE: 'APPLY_DEADLINE_DATE',
  APPLY_SOURCE_DATE_DOCUMENT: 'APPLY_SOURCE_DATE_DOCUMENT',
  APPLY_SOURCE_DATE_NUMBER: 'APPLY_SOURCE_DATE_NUMBER',
  APPLY_TOPIC_IDS: 'APPLY_TOPIC_IDS',
  APPLY_ORGS_FILTER: 'APPLY_ORGS_FILTER',
  APPLY_SOURCE: 'APPLY_SOURCE',
};
